<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-top: 105px;"' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="border shadow p-4 release-note-card bg-white" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 h4 font-weight-bolder" >
                <template #default>✅ لیست تغییرات تاریخ: 1404/06/16 

   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>🔴 نسخه جدید سبد خرید

   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 " >
                <template #default>UI جدید، بازطراحی بخش درگاه، اضافه شدن بخش روش ارسال
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>🔴 محاسبه اتوماتیک نرخ پست   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 " >
                <template #default>قابلیت محاسبه هزینه پستی بر اساس ابعاد و وزن محصول    </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>🔴 فرم پیشرفته   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 " >
                <template #default>فرم مرحله ای جهت گرفتن اطلاعات از کاربر با نظارت ادمین    </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>🔴 کیف پول پیشرفته
   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 " >
                <template #default>قابلیت ساخت بینهایت کیف پول جدید، انتقال اعتبار بین کیف پول ها   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>🔴 خروجی و ورودی Excel
   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='""' class="p-0 m-0 " >
                <template #default>خروجی و ورودی excel از  تمام محصولات یا بر اساس دسته بندی   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mP,mH5 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
